/** The message elements the Punchup form fields render, matched in DOM order so the first one wins. */
const ERROR_SELECTOR = '.punchupFormError, .punchupDateTimeError, [aria-invalid="true"]';

/**
 * Brings the first validation message in a form into view.
 *
 * A Save that fails validation 600px above the button otherwise looks like nothing happened.
 * react-hook-form's own `shouldFocusError` only reaches `register`ed inputs, so the date pickers —
 * which write through `setValue` — are never focused; this walks the DOM instead.
 */
export const scrollFirstErrorIntoView = (form: HTMLElement | null): void => {
	if (!form) return;

	// react-hook-form runs the invalid handler BEFORE it publishes the new errors, so the messages are
	// not on the page yet — wait one task for the render that paints them.
	setTimeout(() => {
		const message = form.querySelector(ERROR_SELECTOR);
		if (!message) return;

		// Every field renders its message as a direct child of its own container, so the parent is the
		// whole field (label + control + message) — scrolling that is what the manager needs to see.
		const target = (message.parentElement ?? message) as HTMLElement;
		// jsdom implements neither layout nor scrollIntoView, so guard rather than crash a test run.
		if (typeof target.scrollIntoView !== 'function') return;
		target.scrollIntoView({ block: 'center', behavior: 'smooth' });
	}, 0);
};
